<div style="background: url('assets/images/bg.jpg');" class="fixed left-0 top-0 min-h-screen min-w-screen"></div>

<div class="px-5 min-h-screen flex justify-content-center align-items-center">
  <div style="box-shadow: 3px 2px 33px -17px rgba(0,0,0,0.75);" class="border-1 surface-border surface-card border-round py-7 px-4 md:px-7 z-1">
    <div class="mb-4">
      <img src="assets/images/png/logo.png" width="150" alt="CogwheelMarketing Logo">
    </div>
    <div class="mb-1">
      <div class="text-900 text-xl font-bold mb-2">Reset Password</div>
      <!-- <span class="text-600 font-medium">Reset your new password</span> -->
    </div>

    @if (verifying) {
      <div class="flex flex-column align-items-center">
        <p-progress-spinner styleClass="w-4rem h-4rem" strokeWidth="4"></p-progress-spinner>
        <p class="text-600 mt-3">Verifying your reset token...</p>
      </div>
    } @else if (showSuccessScreen) {
      <!-- Success Screen -->
      <div class="flex flex-column align-items-center py-5">
        <div class="mb-4 flex align-items-center justify-content-center" 
             style="width: 80px; height: 80px; border-radius: 50%; background: var(--green-100);">
          <i class="pi pi-check" style="font-size: 3rem; color: var(--green-600);"></i>
        </div>
        
        <h2 class="text-900 font-bold mb-2 text-center">Password Updated Successfully!</h2>
        <p class="text-600 mb-4 text-center">Your password has been successfully updated.<br>You can now log in with your new password.</p>
        
        <div class="w-full md:w-25rem">
          <button 
            pButton 
            pRipple 
            type="button"
            label="Go to Login" 
            class="w-full mb-3"
            (click)="navigateToLogin()">
          </button>
          
          <p class="text-center text-600 text-sm">
            Redirecting automatically in {{ countdown }} second{{ countdown !== 1 ? 's' : '' }}...
          </p>
        </div>
      </div>
    } @else {
      <form [formGroup]="formGroup" (ngSubmit)="resetPassword()">
        <div class="flex flex-column">
          <p-fluid>
            @if (showErrorMessage) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="error" class="w-full">Password reset was not successful. Please try it again.</p-message>
              </div>
            }

            @if (control('password').hasError('passwordLength') && control('password').touched) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="warn" class="w-full">Password must be 8-16 characters long.</p-message>
              </div>
            }

            @if (control('password').hasError('passwordUpperCase') && control('password').touched) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="warn" class="w-full">Password must contain at least one uppercase letter.</p-message>
              </div>
            }

            @if (control('password').hasError('passwordLowerCase') && control('password').touched) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="warn" class="w-full">Password must contain at least one lowercase letter.</p-message>
              </div>
            }

            @if (control('password').hasError('passwordNumber') && control('password').touched) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="warn" class="w-full">Password must contain at least one number.</p-message>
              </div>
            }

            @if (control('password').hasError('passwordSymbol') && control('password').touched) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="warn" class="w-full">Password must contain at least one special symbol.</p-message>
              </div>
            }

            @if (formGroup.hasError('notmatched') && control('confirm_password').touched && control('confirm_password').dirty) {
              <div class="w-full md:w-25rem mb-3">
                <p-message severity="warn" class="w-full">Passwords do not match.</p-message>
              </div>
            }

            <div class="w-full md:w-25rem mb-4 mt-2">
              <p-iconfield class="mb-3">
                <p-inputicon>
                  <i class="pi pi-lock"></i>
                </p-inputicon>
                <p-password id="password" formControlName="password" [toggleMask]="true" [feedback]="false" placeholder="New Password" size="large" class="w-full"></p-password>
              </p-iconfield>
              
              <p-iconfield>
                <p-inputicon>
                  <i class="pi pi-lock"></i>
                </p-inputicon>
                <p-password id="confirm-password" formControlName="confirm_password" [toggleMask]="true" [feedback]="false" placeholder="Confirm Password" size="large" class="w-full"></p-password>
              </p-iconfield>
            </div>
          </p-fluid>

          <div class="flex flex-wrap gap-2 justify-content-between">
            <button pButton pRipple label="Cancel" class="flex-auto p-button-outlined" [routerLink]="['/login']"></button>
            <button
              pButton pRipple type="submit"
              label="Update"
              [loading]="loading"
              [disabled]="formGroup.invalid"
              class="flex-auto">
            </button>
          </div>
        </div>
      </form>
    }
  </div>
</div>
